import Vue from 'vue';

const app = {
  state: {
    device: 'desktop',
  },
  mutations: {
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    }
  },
  actions: {
    ToggleDevice({
      commit
    }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js